export const TWO_A_URL = "https://2aelectronics.com/";

export const EvalNote = ({ light = false, className = "" }) => (
  <p className={`text-xs leading-relaxed ${light ? "text-white/60" : "text-[#8A8A8A]"} ${className}`}>
    Evaluations provided by{" "}
    <a
      href={TWO_A_URL}
      target="_blank"
      rel="noopener"
      className={`font-semibold underline underline-offset-2 ${light ? "text-white/80 hover:text-white" : "text-navy hover:text-brand"}`}
    >
      2A Electronics
    </a>
    , our associated Chicago electronics business.
  </p>
);
